export default "__VITE_ASSET__CxzlHFK$__"